module.exports = __webpack_public_path__ + "img/Icon_Leaderboard.122447b8.svg";